import { render, staticRenderFns } from "./PrioridadSolicitud.vue?vue&type=template&id=c6caab36&"
import script from "./PrioridadSolicitud.vue?vue&type=script&lang=js&"
export * from "./PrioridadSolicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports